export const languageOptions = [
    {
        id: 93,
        name: "JavaScript (Node.js 20.5.0)",
        label: "JavaScript (Node.js 20.5.0)",
        value: "javascript",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-original.svg"
    },
    {
        id: 91,
        name: "Java (OpenJDK 21)",
        label: "Java (OpenJDK 21)",
        value: "java21",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/java/java-original.svg"
    },
    {
        id: 92,
        name: "Python (3.11.2)",
        label: "Python (3.11.2)",
        value: "python3.11",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg"
    },
    {
        id: 75,
        name: "C (Clang 7.0.1)",
        label: "C (Clang 7.0.1)",
        value: "c",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/c/c-original.svg"
    },
    {
        id: 76,
        name: "C++ (Clang 7.0.1)",
        label: "C++ (Clang 7.0.1)",
        value: "cpp",
        icon: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/cplusplus/cplusplus-original.svg"
    },
];
